import { StepEditorProps } from "../useStepEditor";
import { prefixForm } from "../../../../utils/FormUtils";
import { Block } from "../../../../components/atoms";
import { StepEditorAccordion } from "../../../workflows/routes/WorkflowEditor/StepEditorAccordion";
import { CompanyEventSelector } from "../../../workflows/routes/WorkflowEditor/StepEditor/AttendToEventEditor/CompanyEventSelector";
import { TagSelector } from "../../../system/tags/TagSelector";
import { RelativeDateEditor } from "../../../../foundation/blocks/RelativeDateEditor";
import { useWorkflowFieldsTagList } from "../../fields/WorkflowFieldTagList";

/**
 * Normalizes legacy field keys to tag path format for backward compatibility.
 * Converts old format (e.g., "emailprivate") to new format (e.g., "employee.emailprivate").
 * Tag paths that already contain dots are returned unchanged.
 */
const normalizeFieldPath = (value: string | null | undefined): string | null => {
  if (!value) return null;
  // If already a tag path (contains dot), return as-is
  if (value.includes('.')) return value;
  // Old format: assume it's an employee field, prefix with "employee."
  return `employee.${value}`;
};

export const AttendToEventStepEditor = ({ form, stepDataPath, workflowId }: StepEditorProps) => {
  const prefixedForm = prefixForm(form, stepDataPath);

  const workflowFieldTagList = useWorkflowFieldsTagList(workflowId);

  return (
    <>
      <Block compact blended>
        <StepEditorAccordion title="Attendance">
          <StepEditorAccordion.Row label="Event">
            <CompanyEventSelector
              companyEventId={prefixedForm.get("companyEventId")}
              onChange={prefixedForm.set("companyEventId")}
            />
          </StepEditorAccordion.Row>
          <StepEditorAccordion.Row label="Attendee">
            <TagSelector
              variant="blended"
              size="small"
              onSelect={tag => prefixedForm.set("attendeeAttribute")(tag.tag)}
              value={normalizeFieldPath(prefixedForm.get("attendeeAttribute"))}
              title="Select attendee"
              ctx={{
                fieldTypes: ["email"],
                workflowId
              }}
            />
          </StepEditorAccordion.Row>
        </StepEditorAccordion>
      </Block>
      <Block compact blended>
        <StepEditorAccordion title="Session timing">
          <StepEditorAccordion.Row label="Earliest">
            <RelativeDateEditor
              value={prefixedForm.get("after")}
              onChange={prefixedForm.set("after")}
              referenceEnabled
              onClear={() => prefixedForm.set("after")(null)}
              placeholder="As soon as possible"
              customReferenceCategories={[workflowFieldTagList]}
              workflowId={workflowId}
            />
          </StepEditorAccordion.Row>
          <StepEditorAccordion.Row label="Latest">
            <RelativeDateEditor
              value={prefixedForm.get("before")}
              onChange={prefixedForm.set("before")}
              referenceEnabled
              onClear={() => prefixedForm.set("before")(null)}
              placeholder="Anytime"
              customReferenceCategories={[workflowFieldTagList]}
              workflowId={workflowId}
            />
          </StepEditorAccordion.Row>
        </StepEditorAccordion>
      </Block>
    </>
  );
};
